import fetch  from "../utils/fetch";


export function projectConfigList(params) {
  return fetch({
    method:'GET',
    url:'/projectConfig/projectConfigList',
    params
  })
}

export function projectConfigZOList(params) {
  return fetch({
    method:'GET',
    url:'/projectConfig/projectConfigZOList',
    params
  })
}


export function addProjectZO(params) {
  return fetch({
    method:'POST',
    url:'/projectConfig/addProjectZO',
    data:params
  })
}

export function deleteProjectZO(params) {
  return fetch({
    method:'POST',
    url:'/projectConfig/deleteProjectZO',
    params

  })
}

export function editProjectZO(params) {
  return fetch({
    method:'POST',
    url:'/projectConfig/editProjectZO',
    data:params

  })
}

export function updateConfigStutas(params) {
  return fetch({
    method:'POST',
    url:'/projectConfig/updateConfigStutas',
    params
  })
}

export function validConfig(params) {
  return fetch({
    method:'POST',
    url:'/projectConfig/validConfig',
    params
  })
}

export function getProjectConfigInfo(params) {
  return fetch({
    method:'POST',
    url:'/projectConfig/getProjectConfigInfo',
    params
  })
}

export function saveProjectConfigInfo(params) {
  return fetch({
    method:'POST',
    url:'/projectConfig/saveProjectConfigInfo',
    data:params
  })
}


export function selectProjectFacilities(params) {
  return fetch({
    method:'GET',
    url:'/projectConfig/selectProjectFacilities',
    params
  })
}

export function labelgetConfigImg(params) {
  return fetch({
    method:'GET',
    url:'/label/getConfigImg',
    params
  })
}
export function labellist(params) {
  return fetch({
    method:'GET',
    url:'/label/list',
    params
  })
}
export function listBizCircle(params) {
  return fetch({
    method:'GET',
    url:'/label/listBizCircle',
    params
  })
}

export function labeledit(params) {
  return fetch({
    method:'POST',
    url:'/label/edit',
    data:params
  })
}
export function labeladdConfigImg(params) {
  return fetch({
    method:'POST',
    url:'/label/addConfigImg',
    data:params
  })
}
export function labeleditConfigImg(params) {
  return fetch({
    method:'POST',
    url:'/label/editConfigImg',
    data:params
  })
}
export function labelremoveConfigImg(params) {
  return fetch({
    method:'GET',
    url:'/label/removeConfigImg',
    params
  })
}

export function labelremove(params) {
  return fetch({
    method:'GET',
    url:'/label/remove',
    params
  })
}
export function saveProjectFacilities(params) {
  return fetch({
    method:'POST',
    url:'/projectConfig/saveProjectFacilities',
    data:params
  })
}
export function projectConfigcondition() {
  return fetch({
    method:'GET',
    url:'/projectConfig/condition',
  })
}

// 周边配套信息查看
export function getTrafficList(fid) {
  return fetch({
    method:'GET',
    url:'projectConfig/getTrafficList',
    params:{
      fid
    }
  })
}
// 保存周边配套
export function saveTrafficList(data) {
  return fetch({
    method:'POST',
    url:'projectConfig/saveTrafficList',
    data
  })
}

